module.exports = __webpack_public_path__ + "img/jyl_banner_touch.eb3cbbf3.png";